<main class="circle-gradient-1">
  <section class="breadcrumb-sec event-sec">
      <div class="container">
          <div class="row g-0">
              <div class="col-lg-6 col-md-6">
                  <ul class="breadcrumb">
                      <li><a routerLink="/">Home</a></li>
                      <li><i class="fa fa-angle-right"></i></li>
                      <li><a href="events">Events</a></li>
                      <li><i class="fa fa-angle-right"></i></li>
                      <li><a routerLink="/events" fragment="cultural">Cultural</a></li>
                      <li><i class="fa fa-angle-right"></i></li>
                      <li>Ashadhi Ekadashi</li>
                  </ul>
                  <div class="sec-title">
                      <h1><span>Ashadhi Ekadashi Celebration</span></h1>
                      <p>Joyful Celebrations at GHRCACS Pune on Ashadhi Ekadashi!
                      </p>
                      <p>From heartfelt performances and captivating speeches to vibrant dances and traditional
                          rituals,
                          our students and faculty embraced the spirit of devotion, discipline, and unity. Here's
                          a
                          glimpse into our wonderful day filled with smiles, culture, and cherished moments!</p>
                  </div>
              </div>
          </div>
          <div class="breadcrumb-overlay overflow-hidden"
              style="background-image: url(https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi1.webp);">
          </div>
      </div>
  </section>

  <section class="section-lg">
    <div class="container">
      <div class="sec-title text-center">
          <h2><span>Photo Gallery</span></h2>
      </div>
      <div class="demo-gallery">
          <ul appLightgallery>
              <li class="grid-item1"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi6.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi6.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi6.webp">
                  </a>
              </li>
              <li class="grid-item2"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi5.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi5.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi5.webp">
                  </a>
              </li>
              <li class="grid-item3 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi4.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi4.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi4.webp">
                  </a>
              </li>
              <li class="grid-item4 "
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi3.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi3.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi3.webp">
                  </a>
              </li>
              <li class="grid-item5 "
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi2.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi2.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi2.webp">
                  </a>
              </li>
              <li class="grid-item6 d-none d-lg-block d-md-block"
                  data-responsive="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi1.webp"
                  data-src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi1.webp">
                  <a href="#">
                      <img class="img-fluid"
                          src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/images/events/ashadhi-ekadashi1.webp">
                  </a>
              </li>
          </ul>
      </div>
    </div>
  </section>
</main>
